import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import dubbahLogo from '../assets/dubbah-logo.png';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img src={dubbahLogo} alt="Dubbah" className="logo-img" />
          </Link>
        </div>

        <button className="mobile-menu-button" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to="/enterprise">Enterprise</Link></li>
            <li>
              <a href="https://petvids.s3.us-east-2.amazonaws.com/dubbah/Dubbah-Studio.dmg" className="cta-button">
                Download for Mac
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
